import React, { useMemo, useState } from 'react'

type Region = {
  id: number
  name: string
}

type County = {
  id: number
  name: string
  region_id?: number
  regionId?: number
}

type RegionCountySelectProps = {
  regions: Region[]
  counties: County[]
  regionId?: number | null
  countyId?: number | null
  regionInputName: string
  countyInputName: string
}

const RegionCountySelect: React.FC<RegionCountySelectProps> = ({
  regions,
  counties,
  regionId = null,
  countyId = null,
  regionInputName,
  countyInputName,
}) => {
  const [selectedRegionId, setSelectedRegionId] = useState<string>(regionId != null ? regionId.toString() : '')
  const [selectedCountyId, setSelectedCountyId] = useState<string>(countyId != null ? countyId.toString() : '')

  const getCountyRegionId = (county: County): string => {
    const regionValue = county.region_id != null ? county.region_id : county.regionId
    return regionValue != null ? regionValue.toString() : ''
  }

  const countyOptions = useMemo(() => {
    const filteredCounties = selectedRegionId
      ? counties.filter((county) => getCountyRegionId(county) === selectedRegionId)
      : counties

    return Array.from(new Map(filteredCounties.map((county) => [county.id, county])).values())
  }, [counties, selectedRegionId])

  const onRegionChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const nextRegionId = event.target.value
    setSelectedRegionId(nextRegionId)
    setSelectedCountyId('')
  }

  return (
    <div className="region-county-select">
      <div className="form-group">
        <label htmlFor="em_program_location_region_id">Region</label>
        <select
          id="em_program_location_region_id"
          className="form-control"
          name={regionInputName}
          value={selectedRegionId}
          onChange={onRegionChange}
        >
          <option value=""></option>
          {regions.map((region) => (
            <option key={region.id} value={region.id}>
              {region.name}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label htmlFor="em_program_location_county_id">County</label>
        <select
          id="em_program_location_county_id"
          className="form-control"
          name={countyInputName}
          value={selectedCountyId}
          onChange={(event) => setSelectedCountyId(event.target.value)}
        >
          <option value=""></option>
          {countyOptions
            .slice()
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((county) => (
              <option key={county.id} value={county.id}>
                {county.name}
              </option>
            ))}
        </select>
      </div>
    </div>
  )
}

export default RegionCountySelect
